// Replaced at bundle time by esbuild `define` (esbuild.mjs); undefined under
// vitest and Storybook, hence the guard.
declare const __BUILD_ID__: string | undefined;

/** Short git SHA of the deployed build, shown in the footer. */
export const BUILD_ID: string =
  typeof __BUILD_ID__ === 'undefined' ? 'dev' : __BUILD_ID__;
